export default __webpack_public_path__ + "static/media/emploTimes.e8deabe0.png";